import get from 'lodash/get';

export function extractLotameInterestsFromNowPlaying(nowPlaying) {
  const genreId = get(nowPlaying, 'classification.genreId');
  const primaryGuideId = get(nowPlaying, 'primaryGuideId');
  const secondaryGuideId = get(nowPlaying, 'secondaryGuideId');

  return [genreId, primaryGuideId, secondaryGuideId].filter(Boolean);
}

export function extractLotameInterestsFromGuideItem(guideItem) {
  const genreId = get(
    guideItem,
    'metadata.properties.classification.primaryGenreId',
  );
  const primaryGuideId = get(guideItem, 'guideId');

  return [genreId, primaryGuideId].filter(Boolean);
}
